// const path = require('path')
// require('dotenv').config({
//   path: path.resolve(__dirname, '../.env'),
//   opt: { debug: true }
// })

export default {
  apiUrl: process.env.API_URL,
  env: process.env
}
